import React, { useContext, useEffect, useState } from 'react'

import { Button, IconButton } from '@material-ui/core'
import FormDialog from '../../../Product/components/organisms/Dialog'
import authContext from '../../../Product/context/auth/authContext'
import schedulePickupContext from '../../../Product/context/plugin/schedulePickup/schedulePickupContext'

const MessagePickup = ({ product, pickupData, sellerData }) => {
    const [messagePopup, setMessagePopup] = useState(false)
    const [trigger, setTrigger] = useState(false)
    const [messages, setMessages] = useState([])
    const [messageInput, setMessageInput] = useState('')
    const { user } = useContext(authContext)
    const { getAllMessages, composeMessage, all_messages, clearAllMessages, responseStatus } =
        useContext(schedulePickupContext)

    const handleChange = (e) => setMessageInput(e.target.value)
    const handleSubmit = (e) => {
        if (!messageInput) {
            return null
        }
        e.preventDefault()
        composeMessage({
            site_id: product?.site_id,
            from_id: user?.id,
            to_id: product?.seller_id,
            random_number: pickupData?.random_number,
            invoice_id: product?.common_invoice,
            lotid: product?.project_id,
            message: messageInput,
        })
    }
    useEffect(() => {
        if (user && product && messagePopup) {
            getAllMessages({
                site_id: product?.site_id,
                user_id: product?.user_id,
                buyerid: user?.id,
                lotid: product?.common_invoice,
            })
        }
    }, [user, product, trigger, messagePopup])
    useEffect(() => {
        setMessages(all_messages.reverse())
    }, [all_messages])
    useEffect(() => {
        return () => {
            clearAllMessages()
        }
    }, [])
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'composeMessage') {
                if (responseStatus.status === 'success') {
                    setMessageInput('')
                    setTrigger(!trigger)
                }
            }
        }
    }, [responseStatus])
    return (
        <div className="">
            <Button className="schedulePickupBtn" onClick={() => setMessagePopup(true)}>
                <span className="material-icons">message</span>
                Message
            </Button>
            <FormDialog
                className="msgPluginDialog"
                open={messagePopup}
                openFunction={() => setMessagePopup(false)}
                aria-labelledby="form-dialog-title"
                title={
                    <>
                        <div className="messagePopupTitle d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div className="usrPrflCrcle mr-3">
                                    {sellerData?.seller_name?.charAt(0)}
                                </div>
                                <div className="msgrPrlNm">
                                    <h2 className="mb-0">{sellerData?.seller_name}</h2>
                                    <p>Seller</p>
                                </div>
                            </div>
                            <IconButton onClick={() => setMessagePopup(false)}>
                                <span className="material-icons">clear</span>
                            </IconButton>
                        </div>
                    </>
                }
                maxWidth={'md'}
            >
                <div className="messagePlgBody">
                    <div className="MessageInrBody">
                        {messages.map((val, key) => (
                            <div
                                className={`${
                                    user?.id == val.from_id ? 'sntMsgWrpr' : 'rcvdMsgWrpr'
                                } msgOtrWrpr`}
                            >
                                <div className="msgContent">{val.message}</div>
                            </div>
                        ))}
                    </div>
                    <div className="msgInputBoxWrpr">
                        <div className="msgInputBox">
                            <textarea
                                placeholder="Enter Message..."
                                value={messageInput}
                                onChange={handleChange}
                            ></textarea>
                            <IconButton className="sndButton" onClick={handleSubmit}>
                                <span className="material-icons">send</span>
                            </IconButton>
                        </div>
                    </div>
                </div>
            </FormDialog>
            {/* <FullScreenPopup open={messagePopup} handleClose={() => setMessagePopup(false)} /> */}
        </div>
    )
}

export default MessagePickup
